import React from 'react';
import { string, shape } from 'prop-types';
import ActionModal from '../../action-modal';
import Iframe from '../../iframe';
import onIframeModalResize from '../../../lib/on-iframe-modal-resize';

const namespace = 'ui-pdp-vis-action-modal';

const BuildVisIframeModal = ({
  type = 'primary',
  hierarchy = 'loud',
  label = null,
  target = null,
  customRef = null,
}) => {
  const buttonProps = {
    type,
    hierarchy,
  };

  return (
    <ActionModal
      label={label}
      modalClassName="ui-pdp-iframe-modal vis-iframe-modal--no-title"
      className={namespace}
      buttonProps={buttonProps}
      controlModalHeader
      {...customRef && { customRef }}
    >
      <Iframe
        onMessage={onIframeModalResize(
          'vip:modal-content:loaded',
          'height',
          '.ui-pdp-iframe-modal',
          '.andes-modal__header',
          'width',
        )}
        data-testid="vis-iframe"
        title={label?.text}
        src={target}
        scrolling="no"
      />
    </ActionModal>
  );
};

BuildVisIframeModal.propTypes = {
  target: string.isRequired,
  type: string,
  hierarchy: string,
  label: shape({
    text: string,
  }),
  customRef: shape({}),
};

export default BuildVisIframeModal;
